import { getOrderItemsByItemId } from '../../selectors/items/get-order-items-by-item-id';
import { removeOrderItem } from './remove-order-item';
export const removeOrderItemsByItemId = (itemId, priceRestriction) => {
    getOrderItemsByItemId(itemId, priceRestriction).forEach(item => {
        removeOrderItem(item.id);
    });
};
